import React from "react";
import servicesData from "../data/ServicesData";

const ServicesContent = ({ serviceKey }) => {
  const service = servicesData.find((service) => service.key === serviceKey);

  if (!service) return null;

  return (
    <div className="srv-content">
      {/* Why Choose Card */}
      {service?.whyChoose && (
        <div className="srv-dist-card">
          <img src={"/dis.jpg"} alt={" why choose"} />
          <div className="row row-gap-25">
            <div className="col-12">
              <h3 className="sec-head sm color-red mb-0">{service?.title}</h3>
            </div>
            <div className="col-lg-7 col-12">
              <div className="srv-dist-card-content">
                <h4 className="sec-head white xsm">
                  {service?.whyChoose?.heading}
                </h4>
                <ul className="srv-dist-card-list white">
                  {service?.whyChoose?.points?.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-5 col-12">
              {service?.whyChoose?.image && (
                <img
                  className="srv-dist-card-img w-100 h-auto"
                  src={service?.whyChoose?.image}
                  alt={service?.title + " why choose"}
                />
              )}
            </div>
          </div>
        </div>
      )}

      {service?.sections &&
        service?.sections?.map((section, idx) => (
          <div key={idx} className="mb-3">
            <h3 className="sec-head xsm">{section?.heading}</h3>
            <p className="para">{section?.content}</p>
          </div>
        ))}
    </div>
  );
};

export default ServicesContent;
